export const VALIDATION_ERROR_MESSAGES_LIST = {
  DECISION: 'decision',
  STATUS: 'Endorsement Status is Required',
  TYPE_OF_POLICY: 'Policy Type is Required',
  POLICY_NUMBER: 'Policy Number is Required',
  PRODUCT_TYPE: 'Product Type is Required',
  PROVIDER: 'Provider is Required',
  INSURANCE_TYPE: 'Insurance Type is Required',
  PRODUCT_SUB_TYPE: 'Product Sub Type is required',
  SUM_INSURED: 'Sum Insured is Required',
  POLICY_START_DATE: 'Start Date is Required',
  POLICY_END_DATE: 'End Date is Required',
  PREMIUM_PAID: 'Premium Paid is Required',
  PREVIOUS_CLAIMED_AMOUNT: 'Previous Claim Amount is Required',
  AGENT_COMMENTS: 'Agent comments required',
  TPA: 'TPA is required',
  TPA_URL: 'TPA URL is required',
  LOCATION: 'Location is required',
  INSURED_NAME: 'Insured Name is Required',
  VEHICLE_NUMBER: 'Vehicle Number is Required',
  VEHICLE_MAKE_MODEL: 'Vehicle Make and Model is Required',
  PERMANENT_EMPLOYEES: 'Number of Permanent Employees is Required',
  CONTRACT_EMPLOYEES: 'Number of Contract Employees is Required',
  EMPLOYEES_COVERED: 'Number of Employees Covered is Required',
  LIVES_COVERED: 'Number of Lives Covered is Required',
  FAMILY_DEFINITION: 'Family Definition is Required',
  AVG_FAMILY: 'Avg Family Size is Required',
  FIRST_NAME: 'First Name is required',
  DATE_OF_BIRTH: 'Date of Birth is required',
  RELATION: 'Relation is required',
  SELF_NEWLY_ADDED: 'No. of Self Newly Added is required',
  DEPENDENTS_NEWLY_ADDED: 'No. of Dependents Newly Added is required',
  DEPENDENTS_DELETED: 'No. of Dependents Deleted is required',
  DELETED_EMPLOYEES: 'Deleted Employees is required',
  PROVIDER_ID: 'Provider Id is REquired',
  PROVIDER_NAME: 'Provider name is required',
  INSURANCE_PROVIDER: 'Insurance provider details are required',
  EMPLOYEE_MIGRATION: 'Required',
  POLICY_DOCUMENT: 'Policy Document is Required',
}

export const NOTIFICATION_ERROR_MESSAGES = {
  UPLOAD: 'Please upload policy document.',
  FIELDS: 'Please fill all the required fields.',
  UPLOAD_SUCCESS: 'Policy Document has been updated successfully.',
  UPLOAD_WARNING: 'Please upload a policy document.',
  COVERAGES: 'Coverages have been updated.',
  COVERAGE_ERROR: 'Encountered an error while updating Coverages.',
}

export const MODAL_MESSAGE = {
  SUBMIT: 'Are you sure to Submit ?',
}

export const COVERAGES_WARNING = {
  EMPTY: 'Coverage cannot be empty',
  EXISTS: 'Coverage already exists',
  LENGTH: 'You can add up to 5 coverages only',
}
